<template>
    <div>
        <h3 style="margin-bottom: 10px;"># 任务完成记录</h3>
        <div class="elTableBox">
            <!-- 表格 -->
            <el-table class="columnClassNav" align="center" :data="tableData" border>
                <el-table-column fixed type="index" label="序号" align="center" width="50">
                </el-table-column>

                <el-table-column prop="taskId" label="任务ID" align="center">
                </el-table-column>

                <el-table-column prop="userPicture" label="用户头像" align="center">
                    <template #default="{ row }">
                        <el-image style="width: 50px; height: 50px" :src="row.userPicture" fit="cover"></el-image>
                    </template>
                </el-table-column>

                <el-table-column prop="nickname" label="用户名称" align="center">
                </el-table-column>

                <el-table-column fixed prop="taskName" label="任务名称" align="center">
                </el-table-column>

                <el-table-column prop="taskType" label="任务类型" align="center">
                    <template #default="{ row }">
                        <el-tag type="primary">{{ taskTypeHandel(row.taskType) }}</el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="createTime" label="完成时间" align="center">
                </el-table-column>

                <el-table-column prop="taskCycle" label="任务周期" align="center">
                    <template #default="{ row }">
                        <el-tag type="primary">
                            {{ row.taskCycle == 0 ? '每日任务' : row.taskCycle == 1 ? '每周任务' : row.taskCycle == 2 ? '每月任务' :
                                row.taskCycle == 3 ? '每年任务' : '无时限任务' }}
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="rewardType" label="奖励数量" align="center">
                    <template #default="{ row }">
                        <span style="margin-right: 5px;">{{ row.rewardQuantity }}</span>
                        <span style="color: #F37B1D;">
                            {{ row.rewardType == 0 ? '经验' : row.rewardType == 1 ? '积分' : row.rewardType == 2 ?
                                '星币' : '未知' }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div style="text-align: right;margin: 20px 20px 0 0;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="params.pageNum" :page-sizes="[10, 20, 30, 50]" :page-size="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="total_pages">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import '@/assets/icon/iconfont.css'
import { getTaskLogApi, getTaskLogByUserIdApi } from '@/api/virtual'
export default {
    name: 'taskCenterPage',
    data() {
        return {
            tableData: '',
            dialogVisible: false,
            dialogTitle: '',
            labelPosition: 'right',
            total_pages: 0,
            params: { pageNum: 1, pageSize: 10 },
            nowFrom: {
                taskType: '',
                taskCycle: '',
                rewardType: '',
                userRewardQuantity: '',
                vipuserRewardQuantity: '',
                taskName: '',
                taskDescribe: ''
            },
            rules: {
                taskName: [
                    { required: true, message: '请输入任务名称', trigger: 'blur' }
                ],
                taskType: [
                    { required: true, message: '请选择任务类型', trigger: 'change' }
                ],
                taskCycle: [
                    { required: true, message: '请选择任务周期', trigger: 'change' }
                ],
                rewardType: [
                    { required: true, message: '请选择奖励类型', trigger: 'change' }
                ],
                userRewardQuantity: [
                    { required: true, message: '请输入普通用户奖励数量', trigger: 'blur' },
                    { type: 'number', message: '奖励数量必须为数字', trigger: 'blur' }
                ],
                vipuserRewardQuantity: [
                    { required: true, message: '请输入VIP用户奖励数量', trigger: 'blur' },
                    { type: 'number', message: '奖励数量必须为数字', trigger: 'blur' }
                ]
            },
            taskTypeMap: {
                0: '发布帖子', 1: '回复帖子', 2: '回复他人评论',
                3: '帖子点赞', 4: '帖子收藏', 5: '帖子转发',
                6: '赠送礼物', 7: '用户充值', 8: '关注用户',
                9: '购买商品', 10: '邀请好友', 11: '每日签到',
                12: '购买会员', 13: '观看广告'
            }
        }
    },
    props: {
        userId: {
            type: Number,
            default: 0
        }
    },
    created() {
        if (this.userId) {
            this.getUserData()
            return
        }
        this.getData()
    },
    methods: {
        taskTypeHandel(type) {
            // 兼容数字/字符串类型的type
            return this.taskTypeMap[Number(type)] || '未知任务类型';
        },
        getData() {
            getTaskLogApi(this.params).then(res => {
                console.log('res', res);

                if (res.code == 200) {
                    this.tableData = res.data.records;
                    this.total_pages = res.data.total;
                } else {
                    this.$message.error(res.msg || '获取列表失败');
                }
            }).catch((err) => {
                this.$message.error(err ? err : '获取列表失败');
            })
        },
        getUserData() {
            getTaskLogByUserIdApi(this.userId, this.params).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data.records;
                    this.total_pages = res.data.total;
                } else {
                    this.$message.error(res.msg || '获取用户信息失败');
                }
            }).catch((err) => {
                this.$message.error(err ? err : '获取用户信息失败');
            })
        },
        handleCurrentChange(number) {
            this.params.pageNum = number;
            if (this.userId) {
                this.getUserData();
                return;
            }
            this.getData();
        },
        handleSizeChange(size) {
            if (this.total_pages >= size) {
                this.params.pageSize = size;
                if (this.userId) {
                    this.getUserData();
                    return;
                }
                this.getData();
            }
        },
        // 对话框关闭前的钩子（补充）
        dialogBeforeClose(done) {
            this.$refs.nowFrom.resetFields();
            done();
        }
    }
}
</script>

<style scoped lang="scss">
.elTableBox {
    display: flex;
    width: 100%;
    padding-right: 20px;
}


// 新增：调整单选框的间距，优化显示
::v-deep .el-radio {
    margin-right: 15px;
    margin-bottom: 10px;
}

.formBodyBox {
    display: flex;
    flex-wrap: no-wrap;

    .formLeftBox {
        width: 48%;
        margin-right: 10px;
        border-right: 1px solid #eee;
        padding: 0 15px;

        .iconNavBox {
            .iconfont {
                font-size: 20px;
            }

            .wyqicon-shiming {
                font-size: 30px;
            }

            .wyqicon-shizixing,
            .wyqicon-jifen {
                font-size: 26px;
            }
        }

        .myIdentity {
            text-align: center;
            font-size: 1.3em;
            font-weight: 550;
            color: black;
        }

        .iconBox {
            margin-top: 15px;
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            text-align: center;

            div {
                flex: 1;
                margin-right: 15px;
                font-size: 14px;
            }

            .iconSex {
                width: 63px;
                background-color: rgb(233, 232, 232);
                height: 20px;
                border-radius: 16px;
                text-align: center;
                line-height: 20px;
                color: black;
                font-size: 10px;
                font-weight: 550;
            }
        }

        .myIDtwoIcon {
            span {
                height: 30px;
                line-height: 30px;
            }
        }

        .ipSee {
            margin-top: 15px;
            font-size: 12px;
            display: flex;
            color: black;

            span {
                flex: 1
            }
        }

        .myName {
            margin: 20px 0;
            text-align: center;

            .spanOne {
                margin-right: 5vw;
            }

            font-size: 14px;
        }

        .navImageBox {
            text-align: center;
        }

        .el-image {
            border-radius: 50%;
        }

        .myIDtwoIcon {
            display: flex;
            justify-content: space-between;
        }
    }

    .formRightBox {
        width: 70%;
        flex-wrap: wrap;

        .el-input {
            margin-right: 15px;
            width: 125px;
            height: 28px;
            line-height: 28px;
        }

        .titleboxSize {
            display: inline-block;
            margin-right: 7px;
            width: 60px;
            text-align: right;
        }

        .el-form-item {
            margin-top: 23px;
        }
    }
}
</style>